import { ConfigurationSettings } from '/models/configuration-settings';
import { SiteConfigurationSettings } from '/models/site-configuration-settings';
import { clients } from 'lib/https';

const fetchConfigurationSettings = async (
  url: string,
  method: string,
  config?: ConfigurationSettings
) => {
  const headers = new Headers();
  if (config && config.blocksKey) {
    headers.append('X-Blocks-Key', config.blocksKey);
  }
  const result = await fetch(url, {
    method: method,
    referrerPolicy: 'no-referrer',
    headers: headers,
  });
  if (!result.ok) {
    throw new Error(`Failed to fetch configuration settings: ${result.statusText}`);
  }
  const data = await result.json();
  if (!data.isSuccess) {
    throw new Error(`Failed to fetch configuration settings`);
  }
  if (!data || typeof data !== 'object') {
    throw new Error('Invalid configuration settings format');
  }
  return data;
};

export const getConfigurationSettings = async () => {
  const url = process.env.REACT_APP_PUBLIC_CONFIGURATION_SETTINGS_URL;
  if (!url) {
    throw new Error('REACT_APP_PUBLIC_CONFIGURATION_SETTINGS_URL is not defined');
  }
  const data = await fetchConfigurationSettings(url, 'GET');
  if (!data.configurationSettings.blocksKey || !data.configurationSettings.paths) {
    throw new Error('Configuration settings are missing required fields');
  }
  return data.configurationSettings as ConfigurationSettings;
};

export const getSiteConfigurationSettings = async (config: ConfigurationSettings) => {
  const url = process.env.REACT_APP_PUBLIC_SECURE_CONFIGURATION_SETTINGS_URL;
  if (!url) {
    throw new Error('REACT_APP_PUBLIC_SECURE_CONFIGURATION_SETTINGS_URL is not defined');
  }
  return await clients.post<SiteConfigurationSettings>(url, config.blocksKey, JSON.stringify({}));
};
